import React from 'react';

const UserIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="490"
    height="490"
    viewBox="0 0 16 17">
    <path fill="#F7FAFC" fillRule="evenodd" d="M4.854 7.445c1.633 1.496 4.13 1.5 5.765.006 1.566.917 2.685 2.58 2.807 4.557.08.816.045 1.388-.107 1.715l-.024.027c-3.012 3.22-8.092 3.226-11.11 0l-.024-.027c-.166-.442-.201-1.012-.104-1.71.13-1.925 1.185-3.618 2.797-4.568zM7.74.973c1.876 0 3.38 1.563 3.322 3.409-.055 2.64-3.135 4.215-5.316 2.571-.768-.566-1.306-1.523-1.328-2.571C4.36 2.538 5.862.972 7.74.972z"/>
  </svg>


);

export default UserIcon;
